<template>
  <div class="container-fluid mt-5">
    <div class="row">
      <div class="col-xl-12 order-xl-1">
        <card>
          <div slot="header" class="row align-items-center">
            <div class="col-8">
              <h3 class="mb-0">{{ $t("PRODUCTS.EDIT_UNIT_OF_MEASURE") }}</h3>
            </div>
            <div class="col-4 text-right">
              <base-button
                @click="goBack"
                type="button"
                class="btn btn-sm btn-primary"
              >
                {{ $t("COMMON.RETURN_TO_LIST") }}
              </base-button>
            </div>
          </div>
          <div class="card-body">
            <unit-of-measure-form
              :loading="loading"
              :unitOfMeasureData="unitOfMeasure"
              :formErrors="formErrors"
              @unitOfMeasureSubmitted="handleSubmit"
              @formChanged="() => (alertLeave = true)"
            />
          </div>
        </card>
      </div>
    </div>
  </div>
</template>

<script>
import UnitOfMeasureForm from "./partials/UnitOfMeasureForm.vue";
import { cloneDeep } from "lodash";
import alertLeave from "@/mixins/alert-leave-mixin";
import defaultUnitOfMeasure from "./defaultUnitOfMeasure";

export default {
  layout: "DashboardLayout",

  components: { UnitOfMeasureForm },

  mixins: [alertLeave],

  data() {
    return {
      unitOfMeasure: cloneDeep(defaultUnitOfMeasure),
      formErrors: null,
      loading: false,
    };
  },

  created() {
    this.get();
  },

  methods: {
    async get() {
      this.loading = true;
      try {
        const id = this.$route.params.id;
        await this.$store.dispatch("unitOfMeasures/get", id);
        this.unitOfMeasure =
          this.$store.getters["unitOfMeasures/unitOfMeasure"];
        this.loading = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.loading = false;
      }
    },

    goBack() {
      this.$router.push({ name: "List UnitOfMeasures" });
    },

    viewUnitOfMeasure() {
      this.alertLeave = false;
      this.$router.push({
        name: "View UnitOfMeasure",
        params: { id: this.unitOfMeasure.id },
      });
    },

    async handleSubmit(unitOfMeasure) {
      this.loading = true;
      const unitOfMeasureData = cloneDeep(unitOfMeasure);

      try {
        await this.$store.dispatch("unitOfMeasures/update", unitOfMeasureData);
        this.$notify({
          type: "success",
          message: this.$t("PRODUCTS.UNIT_OF_MEASURE_UPDATED"),
        });
        this.viewUnitOfMeasure();
        this.loading = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.formErrors = error.response.data.errors;
        this.loading = false;
      }
    },
  },
};
</script>
